function e(e2) {
  const o2 = document.createElement("textarea");
  o2.value = e2, o2.style.top = "0", o2.style.left = "0", o2.style.position = "fixed", document.body.appendChild(o2), o2.focus(), o2.select();
  try {
    const e3 = document.execCommand("copy") ? "successful" : "unsuccessful";
    console.log("Fallback: Copying text command was " + e3);
  } catch (e3) {
    console.error("Fallback: Oops, unable to copy", e3);
  }
  document.body.removeChild(o2);
}
async function o(o2) {
  if (navigator.clipboard) return navigator.clipboard.writeText(o2);
  e(o2);
}
export {
  o as copyTextToClipboard,
  e as fallbackCopyTextToClipboard
};
//# sourceMappingURL=utils.js.map
